module.exports = __webpack_public_path__ + "static/media/oberflex-frakebariole-2560x1440.d3408dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frakebariole-2560x1440.jpg
// module id = 1017
// module chunks = 37